import { TextInput as MTextInput } from '@mantine/core';
import classes from './textInput.module.scss';

export const TextInput = MTextInput.extend({
  classNames: classes,
});
